import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './UserInfo.module.css';
import Icon from '../../../../Icon';

const bindClasses = classNameBind.bind(styles);

const Avatar = ({ email }) => (
  <div className={bindClasses('avatar')}>
    {email.substr(0, 1).toUpperCase()}
  </div>
);

const UserInfo = ({
  email,
  profileLink,
}) => (
  <a
    tabIndex={0}
    className={bindClasses('wrapper')}
    data-ppuc-id="ProductBar.UserInfo"
    href={profileLink}
  >
    <Avatar email={email} />
    <div className={bindClasses('login-container')}>
      <div>{email}</div>
    </div>
    <Icon
      className={bindClasses('chevron-icon')}
      name="chevron-right"
      size="default"
    />
  </a>
);

export { UserInfo };
